import * as R from 'ramda';
import { Map, List, isImmutable } from 'immutable';
import { is, reduceWhile } from 'ramda';
import { SERVICE_TYPE_PER_PERSON, SERVICE_TYPE_PER_PERSON_NIGHT, SERVICE_TYPE_PER_NIGHT} from '../config/constants';
import { get } from '@synergycms_core/utils';
import { DISCOUNT_FLEX_RATE, PROPERTY_MANAGEMENT_GROUP, MANDATORY_FEE_CODE } from '../config/constants';
import moment from 'moment';
import format from 'string-template';
import { keyIn, getPrice, formatCurrencyAmount, isUsDomain } from '@synergycms_core/utils/utils';
import { contentGetter } from '@synergycms_core/content/i18n';
import {UAParser} from 'ua-parser-js';


export const getUniqueRef = (board) => {
  return board && !board.has('any') ? board.keySeq()?.first() : "any"
};


export const getTranslation = (langs, entity, fields, defaultText) => {
  langs = !R.contains('en', langs) ? langs.push('en') : langs;
  if (isImmutable(entity)) {
    if (entity.get('translations')) {
      const translation = entity.get('translations');
      return (
        R.reduceWhile(
          value => !value,
          (acc, lang) => {
            return R.reduceWhile(
              value => !value,
              (acc, field) => {
                return translation.getIn([lang, field]);
              },
              null,
              fields
            );
          },
          null,
          langs
        ) || defaultText
      );
    }
  } else if (is(Object, entity)) {
    if (entity.translations) {
      const translations = entity.translations;
      return (
        R.reduceWhile(
          value => !value,
          (acc, lang) => {
            return R.reduceWhile(
              value => !value,
              (acc, field) => {
                return get([lang, field], translations);
              },
              null,
              fields
            );
          },
          null,
          langs
        ) || defaultText
      );
    }
  } else {
    return defaultText;
  }
};

export const updateIn = R.curry((path, val, obj) =>
  R.compose(
    R.set(R.__, val, obj),
    R.apply(R.compose),
    R.map(R.cond([[R.is(Number), R.lensIndex], [R.T, R.lensProp]]))
  )(path)
);

/**
 *
 * @param number
 * @param decimals
 * @returns {number}
 */
export const round = (number, decimals = 2) => Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);

/**
 *
 * @param input
 * @returns {string}
 */
export const lowerFirst = input => input.charAt(0).toLowerCase() + input.substring(1, input.length);

/**
 *
 * @param cityLat
 * @param cityLon
 * @param hotelLat
 * @param hotelLon
 * @returns {number}
 */
export const getDistance = function (cityLat, cityLon, hotelLat, hotelLon) {
  cityLat = parseFloat(cityLat);
  cityLon = parseFloat(cityLon);
  hotelLat = parseFloat(hotelLat);
  hotelLon = parseFloat(hotelLon);
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(hotelLat - cityLat); // deg2rad below
  const dLon = deg2rad(hotelLon - cityLon);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(cityLat)) * Math.cos(deg2rad(hotelLat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
};

/**
 *
 * @param deg
 * @returns {number}
 */
const deg2rad = function (deg) {
  return deg * (Math.PI / 180);
};

/**
 *
 * @param number
 * @param decPlaces
 * @param thouSeparator
 * @param decSeparator
 * @returns {string}
 */
export const formatNumber = (number, decPlaces, thouSeparator, decSeparator) => {
  decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces;
  thouSeparator = thouSeparator === undefined ? ',' : thouSeparator;
  decSeparator = decSeparator === undefined ? '.' : decSeparator;
  const sign = number < 0 ? '-' : '';
  const i =
    parseInt((number = Number(Math.round(Math.abs(+number || 0) + 'e' + decPlaces) + 'e-' + decPlaces)), 10) + '';
  const j = i.length > 3 ? i.length % 3 : 0;
  return (
    sign +
    (j ? i.substr(0, j) + thouSeparator : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thouSeparator) +
    (decPlaces
      ? decSeparator +
      Number(Math.round(Math.abs(number - i) + 'e' + decPlaces) + 'e-' + decPlaces)
        .toFixed(decPlaces)
        .slice(2)
      : '')
  );
};

/**
 * Funció que chequeja si hi ha algun segment sense dispo o per cas contrari tots en tenen
 * @param roomsAvail
 * @param flexible
 * @returns {boolean}
 */
export const checkAvailSegments = (roomsAvail, flexible = false) => {
  //let success = !(!roomsAvail || roomsAvail.get('success') === false);

  let success = roomsAvail && roomsAvail.every((refTypeGroup,idx) => {
    return idx % 2 !== 0 || refTypeGroup.get('success');
  });

  success = success && !roomsAvail.groupBy((refs) => {
    return refs && refs.get("occup_group_id");
  }).valueSeq().find((roomAvailOccup) => {
    const segments = roomAvailOccup.size / (flexible ? 1 : 2);
    let totalQuotas = Map();
    if (segments > 1) {
      roomAvailOccup.getIn([0, 'rooms'], List()).forEach(room => {
        room.get('days', List()).forEach(day => {
          totalQuotas = totalQuotas.set(
            day.get('day'),
            totalQuotas.get(day.get('day'), 0) + day.getIn(['boards', 0, 'quota'], 0)
          );
        });
      });
      return totalQuotas.every(value => {
        return value < segments;
      });
    }
    return false;
  });


  return success;
};

/**
 *
 * @param bookingBlocks
 * @returns {*}
 */
export const getSegmentsFilled = bookingBlocks => {
  return bookingBlocks.reduce((segmentsFilled, block) => {
    return block.has('room_id') ? segmentsFilled + 1 : segmentsFilled + 0;
  }, 0);
};


/**
 *
 * @param objectMap
 * @returns {function(...[*]): *}
 */
export const immutablePick = objectMap => (...keys) => objectMap.filter(keyIn(...keys));



/**
 *
 */
export const splice = (input, start, delCount, newSubStr) => {
  return input.slice(0, start) + newSubStr + input.slice(start + Math.abs(delCount));
};

const getReservationBlocks = (store) => {
  const currentStep = store.getIn(['customer', 'step', 'current_step', 'code']);
  const reservation = store.getIn(['customer', 'reservation']);
  const key = ((currentStep === 'customerForm' || currentStep === 'confirmation') && reservation && reservation.size > 0)
    ? 'reservation'
    : 'reservation_request';
  const blocks = store.getIn(['customer', key, 'blocks']);

  return blocks;
}

/**
 *
 * @param store
 * @returns {Map<any, any>|Map<string, number>}
 */
export const getReservationTotals = (store, forceTaxes = null, customBlocks = false) => {
  let totalPrice = 0;
  let roomsPrice = 0;
  let servicesPrice = 0;
  let totalDiscount = 0;

  const hotelId = store.getIn(['customer', 'current_hotel']);
  //const showTaxes = forceTaxes || store.getIn(['hotels', hotelId, 'show_taxes']);
  const showTaxes = forceTaxes !== null ? forceTaxes : store.getIn(['hotels', hotelId, 'show_taxes']);
  //const reservationBlocks = customBlocks || getReservationBlocks(store);
  const reservationBlocks = customBlocks || store.getIn(['customer', 'reservation_request', 'blocks']);
  const hotelAvail = store.getIn([
      'avail',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono", "query_params"])]),
      'response'
    ]);
  const servicesAvail = store.getIn([
      'availServices',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', 'service_query_params']),
      'response',
      'services'
    ]);
  if (hotelAvail) {
    reservationBlocks && reservationBlocks.forEach(block => {
      const roomPrice = showTaxes ? block.get('price_tax') : block.get('price');
      totalDiscount += Math.abs(block.get('discount_amount'));

      const blockServiceId = block.get('service_id', false);

      block.get('services').forEach(service => {
        const serviceId = service.get('service_id');
        if (serviceId) {
          const serviceInfo = servicesAvail.find(availService => availService.get('id') === serviceId);
          if(serviceInfo) {
            const serviceType = serviceInfo.get('type').toUpperCase();

            if (!parseInt(blockServiceId, 10) > 0 || blockServiceId !== serviceId) {

              let servicePrice;
              if(serviceInfo.get('works_with_quota', false)) {
                if(service.get('dates', List()).size) {
                  servicePrice = service.get('dates', List()).reduce((acc, date) => {
                    let dayPrice = serviceInfo.get('days', List()).find(day => day.get('day') === date.get('day'));
                    let quantity = date.get('quantity');
                    if(serviceType === SERVICE_TYPE_PER_PERSON || serviceType === SERVICE_TYPE_PER_PERSON_NIGHT) {
                      if (serviceInfo.get('has_price_per_child', false)) {
                        const serviceChildPrice = showTaxes ? serviceInfo.get('child_price_tax') : serviceInfo.get('child_price');
                        const adultDayPrice = showTaxes ? dayPrice.get('price_tax') : dayPrice.get('price');
                        const roomAvail = hotelAvail.getIn([block.get('idx') - 1, block.get('room_id').toString()]);
                        const adultOccupants = parseInt(roomAvail.get('adults', 0));
                        const childOccupants = parseInt(roomAvail.get('childs', 0));

                        return acc + (adultDayPrice * adultOccupants + (serviceChildPrice * childOccupants));
                      } else {
                        quantity = parseInt(block.get('adults', 0)) + parseInt(block.get('childs', 0));
                        return acc + (showTaxes ? dayPrice?.get('price_tax') : dayPrice?.get('price')) * quantity;
                      }
                    } else {
                      return acc + (showTaxes ? dayPrice?.get('price_tax') : dayPrice?.get('price')) * quantity;
                    }
                  }, 0);
                } else if (serviceType === SERVICE_TYPE_PER_NIGHT ) {
                  servicePrice = (showTaxes ? serviceInfo.get('price_tax') : serviceInfo.get('price'));
                } else if (serviceType === SERVICE_TYPE_PER_PERSON_NIGHT){
                  var nOccupants = parseInt(block.get('adults', 0)) + parseInt(block.get('childs', 0));
                  servicePrice = (showTaxes ? serviceInfo.get('price_tax') : serviceInfo.get('price')) * nOccupants;
                }
                else {
                  servicePrice = (showTaxes ? serviceInfo.get('price_tax') : serviceInfo.get('price')) * service.get('quantity');
                }
              } else {
                servicePrice =
                  (showTaxes ? serviceInfo.get('price_tax') : serviceInfo.get('price')) * service.get('quantity');
              }

              if (serviceType === SERVICE_TYPE_PER_PERSON || serviceType === SERVICE_TYPE_PER_PERSON_NIGHT) {
                if(!serviceInfo.get('works_with_quota', false)) {
                  const roomAvail = hotelAvail.getIn([block.get('idx') - 1, block.get('room_id').toString()]);
                  const adultOccupants = parseInt(roomAvail.get('adults', 0));
                  const childOccupants = parseInt(roomAvail.get('childs', 0));
                  if (serviceInfo.get('has_price_per_child', false)) {
                    const serviceChildPrice = showTaxes ? serviceInfo.get('child_price_tax') : serviceInfo.get('child_price');
                    servicePrice = (servicePrice * (adultOccupants) + (serviceChildPrice * childOccupants));
                  } else {
                    servicePrice = servicePrice * (adultOccupants + childOccupants);
                  }
                }
              }

              servicesPrice = servicesPrice + servicePrice;
              totalPrice = totalPrice + servicePrice;
            }
          }
        }
      });

      roomsPrice = roomsPrice + roomPrice;
      totalPrice = totalPrice + roomPrice;
    });
  }
  return Map({
    rooms_price: roomsPrice,
    services_price: servicesPrice,
    total_price: totalPrice,
    discount_amount: totalDiscount,
    discount_percent: round((totalDiscount * 100) / (totalPrice + totalDiscount), 0)
  });
};

export const getReservationTotalsBothModes = (store) => {
  const withTaxes = getReservationTotals(store, true);
  const withoutTaxes = getReservationTotals(store, false);

  return Map({
    with_taxes: withTaxes,
    without_taxes: withoutTaxes,
  });
};

/**
 * Funcio per recuperar les diferencies entre 2 objectes, perfecte per controlar els canvis a les props i refresh de components
 * @param {*}
 * @param {*}
 * @returns {*}
 */

const isObject = R.compose(
  R.equals('Object'),
  R.type
);
const allAreObjects = R.compose(
  R.all(isObject),
  R.values
);
const hasLeft = R.has('left');
const hasRight = R.has('right');
const hasBoth = R.both(hasLeft, hasRight);
const isEqual = R.both(
  hasBoth,
  R.compose(
    R.apply(R.equals),
    R.values
  )
);

const markAdded = R.compose(
  R.append(undefined),
  R.values
);
const markRemoved = R.compose(
  R.prepend(undefined),
  R.values
);
const isAddition = R.both(hasLeft, R.complement(hasRight));
const isRemoval = R.both(R.complement(hasLeft), hasRight);

export const objectDiff = R.curry(_diff);

function _diff(l, r) {
  return R.compose(
    R.map(
      R.cond([
        [isAddition, markAdded],
        [isRemoval, markRemoved],
        [
          hasBoth,
          R.ifElse(
            allAreObjects,
            R.compose(
              R.apply(objectDiff),
              R.values
            ),
            R.values
          )
        ]
      ])
    ),
    R.reject(isEqual),
    R.useWith(R.mergeWith(R.merge), [R.map(R.objOf('left')), R.map(R.objOf('right'))])
  )(l, r);
}

export const dispatchEvent = (name, detail) => {
  const event = new CustomEvent(name, { detail });
  document.dispatchEvent(event);
};

export const parseServices = (hotelInfo, reservationBlocks, hotelAvail, serviceAvailResponse, grupedByBlock = false) => {
  if (reservationBlocks && hotelAvail) {
    let parsedServices = reservationBlocks.reduce((services, block) => {
      const blockServiceId = block.get('service_id');
      block.get('services').forEach(service => {

        const serviceId = service.get('service_id', false);

        if (serviceId) {

          const serviceKey = services.findIndex(s => serviceId === s.get('service_id'));
          const serviceInfo = serviceAvailResponse.get('services').find(availService => availService.get('id') === serviceId);

          if (serviceInfo) {

            let servicePrice = calculateServicePrice(serviceInfo, service, hotelInfo, block, hotelAvail);

            if (!parseInt(blockServiceId, 10) > 0 || blockServiceId !== serviceId) {
              const key = service.get('dates', false) ? 'dates' : 'days';
              if (service.get(key, List()).size) {
                service.get(key, List()).forEach(date => {

                  let momentDate = moment(date.get('day'));
                  let formattedDate = momentDate.format('D MMMM');

                  if (date.get('time', false)) {
                    momentDate = momentDate.add(moment(date.get('time'), 'HH:mm:ss').get('hour'), 'hour');
                    formattedDate = momentDate.format('D MMMM - HH:mm') + " h";
                  }

                  const dateTimeIdx = services.findIndex(s => {
                    return s.get('service_id') === service.get('service_id') && s.get('stringDate') === formattedDate;
                  });

                  let dayTimePrice = serviceInfo.get('days', List()).find(day => day.get('day') === date.get('day'));
                  servicePrice = calculateServicePrice(serviceInfo, date, hotelInfo, block, hotelAvail, dayTimePrice);

                  if (dateTimeIdx !== -1) {
                    if(grupedByBlock) {
                      services = services.push(Map({
                        service_id: service.get('service_id'),
                        quantity: date.get('quantity'),
                        price: servicePrice,
                        stringDate: formattedDate,
                        momentDate: momentDate,
                        blockIdx: block.get('idx'),
                      }));
                    } else {
                      let newService = services.get(dateTimeIdx);
                      services = services.delete(dateTimeIdx);

                      newService = newService.set('quantity', newService.get('quantity') + date.get('quantity'))
                                             .set('blockIdx', block.get('idx'))
                                             .set('price', newService.get('price') + servicePrice)
                                             .set('momentDate', momentDate);

                      services = services.push(newService);
                    }
                  } else {
                    services = services.push(Map({
                      service_id: service.get('service_id'),
                      quantity: date.get('quantity', 1),
                      price: servicePrice,
                      stringDate: formattedDate,
                      momentDate: momentDate,
                      blockIdx: block.get('idx'),
                    }));
                  }

                });
              } else {
                if (serviceKey !== -1) {
                  services = services
                    .setIn([serviceKey, 'blockIdx'], block.get('idx'))
                    .setIn([serviceKey, 'quantity'], service.get('quantity') + services.getIn([serviceKey, 'quantity']))
                    .setIn([serviceKey, 'price'], servicePrice + services.getIn([serviceKey, 'price']));
                } else {
                  services = services.push(service.set('price', servicePrice).set('blockIdx', block.get('idx')));
                }
              }

            }
          }
        }

      });
      return services;
    }, List());

    parsedServices = parsedServices.sort((a, b) => {
      if (!a.get('momentDate')) {return -1;}
      if (!b.get('momentDate')) {return 1;}
      return a.get('momentDate').isBefore(b.get('momentDate')) ? -1 : 1;
    });

    return parsedServices;
  }
};

const calculateServicePrice = (serviceInfo, service, hotelInfo, block, hotelAvail, dayTimePrice = null) => {
  const serviceType = serviceInfo.get('type').toUpperCase();

  let servicePrice;
  if(dayTimePrice) {
    servicePrice = (hotelInfo.get('show_taxes') ? dayTimePrice.get('price_tax') : dayTimePrice.get('price')) * service.get('quantity', 1);
  } else {
    servicePrice = (hotelInfo.get('show_taxes') ? serviceInfo.get('price_tax') : serviceInfo.get('price')) * service.get('quantity', 1);
  }
  if (serviceType === SERVICE_TYPE_PER_PERSON || serviceType === SERVICE_TYPE_PER_PERSON_NIGHT) {
    const roomAvail = hotelAvail.getIn([block.get('idx') - 1, block.get('room_id').toString()]);
    const adultOccupants = parseInt(roomAvail.get('adults', 0));
    const childOccupants = parseInt(roomAvail.get('childs', 0));
    const totalOccupants = adultOccupants + childOccupants

    if (serviceInfo.get('has_price_per_child', false)) {

      let servicePriceChild;
      let servicePriceAdult;
      if(hotelInfo.get('show_taxes')) {
        servicePriceChild = serviceInfo.get('child_price_tax', 0);
        servicePriceAdult = (dayTimePrice ? dayTimePrice.get('price_tax') : serviceInfo.get('price_tax'));
      } else {
        servicePriceChild = serviceInfo.get('child_price', 0);
        servicePriceAdult = (dayTimePrice ? dayTimePrice.get('price') : serviceInfo.get('price'));
      }

      servicePrice = (servicePriceAdult * adultOccupants) + (servicePriceChild * childOccupants);

    } else {
      if(hotelInfo.get('show_taxes')) {
        servicePrice = (dayTimePrice ? dayTimePrice.get('price_tax') : serviceInfo.get('price_tax')) * totalOccupants;
      } else {
        servicePrice = (dayTimePrice ? dayTimePrice.get('price') : serviceInfo.get('price')) * totalOccupants;
      }
    }
  }

  return servicePrice;
};

export const isRefundable = (
  hotelAvail,
  reservationBlocks,
  parsedServices,
  serviceAvailResponse,
  managementGroupID,
  fromStorage = false
) => {
  let refundable = true;
  if (reservationBlocks && is(List, hotelAvail) && hotelAvail.size > 0 && hotelAvail) {
    hotelAvail.keySeq().forEach(key => {
      const block = reservationBlocks.get(key, false);
      if(block) {
        const roomId = fromStorage ? block.get('room_id').toString() : block.get('room_id');
        const serviceId = block.get('service_id');
        const boardId = fromStorage ? block.get('board_id').toString() : block.get('board_id');
        const roomAvail = hotelAvail && hotelAvail.getIn([key, serviceId ? roomId + '-' + serviceId : roomId]);
        const boardAvail = roomAvail && roomAvail.getIn(['boards', boardId, block.get('unique_ref_type')]);
        const firstDay = boardAvail && boardAvail.get('days').first();
        const flexDiscount = (boardAvail && boardAvail.get('discounts', List()).find(d => (d.get('acronym', '') || '').indexOf(DISCOUNT_FLEX_RATE) === 0)) || false;
        let flexDiscountNew = (boardAvail && boardAvail.get('discounts', List()).find(d => d.get('flexible', false))) || false;
        if (!flexDiscountNew) {
          flexDiscountNew = firstDay && firstDay.get('flexible', false) && firstDay;
        }
        if (!(flexDiscountNew && flexDiscountNew.get('flexible_release', 0) > 0)) {
          flexDiscountNew = false;
        }

        if (flexDiscount && PROPERTY_MANAGEMENT_GROUP !== managementGroupID && !boardAvail.get('refundable', false)) {
          const daysRelease = flexDiscount ? flexDiscount.get('acronym').split(DISCOUNT_FLEX_RATE)[1] : 0;
          const releaseDay = moment(boardAvail.get('days').keySeq().first()).subtract(daysRelease, 'd');
          const daysDiff = releaseDay.diff(moment(), 'd', true);
          const applyPenaltyRelease = daysDiff <= 0;
          refundable = refundable && !applyPenaltyRelease;
        } else {
          refundable = refundable && boardAvail && boardAvail.get('refundable', false) === true && !flexDiscount && !flexDiscountNew;
        }
      }
    });

    parsedServices.keySeq().forEach(key => {
      const service = parsedServices.get(key),
        serviceInfo = serviceAvailResponse
          .get('services')
          .find(availService => +availService.get('id') === +service.get('service_id'));
      if (!serviceInfo.get('has_closed_price', false)) {
        refundable = refundable && serviceInfo.get('refundable', false) === true;
      }
    });
  }

  return reservationBlocks ? refundable : undefined;
};



export const reduceWhileResolved = (store, storeKey, hotelsIds = null) => {
  hotelsIds = hotelsIds || store.getIn(['customer', 'current_hotels']);

  const itemsResolveds = reduceWhile(
    (itemsResolveds, hotelId) => {
      if (storeKey === 'hotels') {
        return is(Boolean, store.getIn([storeKey, hotelId, 'success']));
      } else {
        
        const hotelParams = store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "multi", "base_query_params"])]);

        const params = store.getIn(["customer", "params", store.getIn(["availQuery", "multi", "query_params"])]);

        const queryParams = params === hotelParams && hotelParams;
        return store.getIn([storeKey, hotelId, queryParams, 'raw_response']);
      }
    },
    (itemsResolveds, hotelId) => itemsResolveds.set(hotelId, store.getIn([storeKey, hotelId])),
    Map(),
    hotelsIds
  );
  return hotelsIds.size > 0 && hotelsIds.size === itemsResolveds.size ? itemsResolveds : undefined;
};

export const cleanHotelPreferences = hotelPreferences =>
  hotelPreferences.reduce((preferences, preference) => {
    if (preference.get('options').size > 0) {
      return preferences.push(preference);
    } else {
      return preferences;
    }
  }, List());

export const addScripts = (hotelDetails, referer, step) => {
  const scripts = hotelDetails.getIn(['extended_scripts'], undefined);

  if (scripts.size > 0 && referer) {
    scripts.forEach(scriptValues => {
      if (scriptValues.getIn(['referer']) === referer) {
        const existElement = document.getElementById(referer);
        const location = scriptValues.getIn(['location'], undefined);
        const showScript = location && location.includes(step);
        const existScript = scriptValues.getIn(['script'], undefined);
        if (!existElement && showScript) {
          if (existScript) {
            const script = document.createElement('div');
            script.innerHTML = existScript;
            let cloneScript = document.createElement("script");
            cloneScript.id = referer;
            let node = script.firstChild;
            node.attributes.forEach(function (element) {
              cloneScript.setAttribute(element.name, element.value);
            });
            document.body.appendChild(cloneScript);
          }
        }
        else if (existElement && !showScript) {
          document.getElementById(referer).remove();
        }
      }
    });
  }
};

export const getPrepaymentText = (
  requiredPrepayment,
  requiredPrepaymentValue,
  requiredPrepaymentType,
  currencies,
  currentCurrencyCode,
  hotelCurrencyCode,
  langInfo,
  content,
  forceHotelCurrency = false
) => {
  const currentCurrency = currencies.find(c => c.get('code') === currentCurrencyCode);
  const hotelCurrency = currencies.find(c => c.get('code') === hotelCurrencyCode);

  let translationType = '';
  switch (requiredPrepaymentType) {
    case 'percentage':
      translationType = content.t('del {prepayment_value}% del total de la reserva');
      translationType = format(translationType, { prepayment_value: requiredPrepaymentValue });
      break;
    case 'nights':
      translationType = content.t('de {prepayment_value} noches');
      translationType = format(translationType, { prepayment_value: requiredPrepaymentValue });
      break;
    default:
      if (!forceHotelCurrency && hotelCurrency && hotelCurrency.get('code') !== currentCurrency.get('code')) {
        requiredPrepayment = getPrice(requiredPrepayment, hotelCurrency.get('ratio'), currentCurrency.get('ratio'));
      }
      requiredPrepayment = formatCurrencyAmount(currencies, currentCurrency, langInfo)(requiredPrepayment, currentCurrency.get('code'), currentCurrency.get('decimals'));
      translationType = content.t('de {prepayment_value}');
      translationType = format(translationType, { prepayment_value: requiredPrepayment });
      break;
  }

  return format(content.t('Se solicita prepago {prepayment_type} para la confirmaci\u00f3n de esta reserva.'), { prepayment_type: translationType });
};

export const isIE = () => {
  // IE 10 and IE 11
  return /Trident\/|MSIE/.test(window.navigator.userAgent);
};

export const isAppleDevice = () => {
  const parser = new UAParser();
  const device = parser.getDevice();
  const os = parser.getOS();
  const appleVendors = ['Apple'];
  const appleOS = ['iOS', 'Mac OS'];

  return (
    (device.vendor && appleVendors.includes(device.vendor)) ||
    (os.name && appleOS.includes(os.name))
  );

};

const ONLINE_PAYMENT_CODES = ['op', 'paypal', 'amazon_pay'];

export const shouldShowTaxes = (hotel, reservationObj) => {
  const showTaxes = hotel && hotel.get('show_taxes', false);

  if (showTaxes) return true;
  return false;

  /*const giftVoucherAmount = reservationObj && reservationObj.getIn(['payment', 'amount_promo_paid'], 0);
  const pointsPaymentAmount = reservationObj && reservationObj.getIn(['loyalty', 'total_points_price'], 0);
  const totalDiscountAmount = pointsPaymentAmount + giftVoucherAmount;
  const bookTotalPrice = reservationObj && reservationObj.getIn(['total_price'], 0);

  // Forzar showTaxes si los descuentos aplicados cubren el total de la reserva
  if (totalDiscountAmount >= bookTotalPrice) return true;

  const payformCode = reservationObj && reservationObj.getIn(['payment', 'payform_code'], '');

  // Forzar showTaxes si el metodo de pago es: pago online, paypal
  if (ONLINE_PAYMENT_CODES.includes(payformCode)) return true;

  return false;*/
};

export const parseTaxesPreview = (hotel, hotelAvail, services, reservationRequest, mode) => {
  const blocks = reservationRequest && reservationRequest?.get('blocks');

  if (!blocks || !hotelAvail) {
    return { included: [], nonIncluded: [] };
  }

  const hotelTaxes = hotel && hotel?.get('taxes', false);
  const localTaxes = hotel && hotel?.get('localTaxes');
  const showTaxes = hotel && hotel?.get('show_taxes', false);

  const enrichedBlocks = blocks.map((block, index) => {
    const roomId = block.get('room_id');
    const boardId = block.get('board_id');
    const serviceId = block.get('service_id');
    const roomKey = serviceId ? `${roomId}-${serviceId}` : `${roomId}`;
    const availGroup = hotelAvail?.get(index);
    const roomAvail = availGroup?.get(roomKey);
    const boardAvail = roomAvail?.getIn(['boards', boardId, block.get('ref_type')]);

    const days = boardAvail?.get('days') ?? List();
    const totalTaxAmount = days.reduce((sum, day) => sum + (day.get('tax_amount', 0)), 0);
    const dayData = days.first();

    const mergedLocalTaxes = days.reduce((acc, day) => {
      const dayLocalTaxes = day.get('local_taxes', List());
      dayLocalTaxes.forEach((localTax) => {
        const taxId = localTax.get('id');
        if (acc[taxId]) {
          acc[taxId] = acc[taxId].set('tax_amount', acc[taxId].get('tax_amount') + localTax.get('tax_amount', 0));
        } else {
          acc[taxId] = localTax;
        }
      });
      return acc;
    }, {});

    const enrichedServices = block.get('services', List()).map(blockService => {
      const serviceInfo = services
        ? services.find(s => s.get('id') === blockService.get('service_id'))
        : null;
      if (!serviceInfo) return blockService;

      const normalizedServiceInfo = serviceInfo
        .set('tax_percent', serviceInfo.get('tax_percentage'))
        .delete('tax_percentage');

      return blockService.merge(normalizedServiceInfo);
    });

    return block
      .set('local_taxes', List(Object.values(mergedLocalTaxes)))
      .set('tax_amount', totalTaxAmount)
      .set('taxes_included', (dayData?.get('taxes_included') || showTaxes) ?? false)
      .set('tax_id', dayData?.get('tax_id') ?? null)
      .set('services', enrichedServices);
  });

  // Calculamos el valor de los impuestos de las tarifas
  let rateTaxes = enrichedBlocks.reduce((acc, block) => {
    const tax_id = block.get('tax_id');
    const tax_amount = block.get('tax_amount', 0);
    const taxes_included = block.get('taxes_included', false);

    const hotelTax = hotelTaxes && hotelTaxes.find((tax) => tax.get('id') === tax_id);
    const hotelTaxInfo = hotelTax?.get('info');

    if (hotelTaxInfo) {
      const key = `iva-${hotelTaxInfo.first().get('amount')}`;
      if (acc[key]) {
        acc[key].tax_amount += tax_amount;
      } else {
        acc[key] = {
          is_percent: hotelTaxInfo.first().get('is_percent'),
          value: hotelTaxInfo.first().get('amount'),
          name: 'iva',
          tax_amount: tax_amount,
          include_total_price: taxes_included,
        };
      }
    }
    return acc;
  }, {});

  // Calculamos valor de los impuestos locales y de los servicios
  const localTaxesBlocks = enrichedBlocks.size > 0 ? Object.values(enrichedBlocks.reduce((acc, block) => {
    acc = calculateLocalTaxes(block, acc, localTaxes);
    acc = calculateServicesTaxes(block, acc, showTaxes, mode);
    return acc;
  }, {})) : [];

  return mergeTaxesAndClassify(rateTaxes, localTaxesBlocks, showTaxes, mode);
};

export const parseTaxes = (hotel, reservationObj, mode = "default") => {
  const blocks = reservationObj && reservationObj?.get('blocks');
  const localTaxes = hotel && hotel?.get('localTaxes');
  const rates = reservationObj && reservationObj?.get('rates');
  const hotelTaxes = hotel && hotel?.get('taxes', false);
  const showTaxes = shouldShowTaxes(hotel, reservationObj) ?? true;

  let rateTaxes = calculateRateTaxes(rates, hotelTaxes, blocks);

  const localTaxesBlocks = blocks?.size > 0 ? Object.values(blocks.reduce((acc, block) => {
    acc = calculateLocalTaxes(block, acc, localTaxes);
    acc = calculateServicesTaxes(block, acc, showTaxes, mode);
    return acc;
  }, {})) : [];

  return mergeTaxesAndClassify(rateTaxes, localTaxesBlocks, showTaxes, mode);
};

const calculateRateTaxes = (rates, hotelTaxes, blocks) => {

  let rateTaxes = rates.size > 0 ? rates.reduce((acc, rate) => {
    let hotelTax = hotelTaxes && hotelTaxes.find((tax) => tax.get("id") === rate.get('tax_id'));
    let hotelTaxInfo = hotelTax && hotelTax?.get('info');

    hotelTaxInfo && acc.push({
      is_percent: hotelTaxInfo.first().get('is_percent'),
      value: hotelTaxInfo.first().get('amount'),
      name: 'iva',
      tax_type: 'rate',
      tax_amount: blocks.reduce((sum, block) => {
        if(!block.get('rates', List()).size) return sum;
        return block.get('rates', List()).includes(parseInt(rate.get('id'))) ? sum + block.get('tax_amount') : sum;
      }, 0),
      include_total_price: rate.get('taxes_included')
    });
    return acc;
  }, []) : [];

  return rateTaxes.reduce((acc, tax) => {
    const key = `${tax.value}-${tax.is_percent}`;
    if (acc[key]) {
      acc[key].tax_amount += tax.tax_amount;
    } else {
      acc[key] = tax;
    }
    return acc;
  }, []);

}

const calculateLocalTaxes = (block, acc, localTaxes) => {
  let taxes = block.get('local_taxes');
  if(!taxes.size) return acc;

  taxes.forEach((tax) => {
    let taxId = tax.get('id');
    if(acc[taxId]) {
      acc[taxId].tax_amount += tax.get('tax_amount');
    } else {
      acc[taxId] = tax.toJS();
      Object.assign(acc[taxId], localTaxes.toJS().find(({id}) => id === taxId));
    }
  });
  return acc;
}

const calculateServicesTaxes = (block, acc, showTaxes, mode = 'default') => {
  const blockServices = block.get('services', List());
  if (!blockServices.size) return acc;

  blockServices.forEach((service) => {
    const taxPercent = service.get('tax_percent');
    if (!taxPercent || service.get('price_tax') <= 0) return;

    const srvTaxesIncluded = service.get('taxes_included');

    const taxAmount = getServiceTaxAmount(block, service);
    if (taxAmount <= 0) return;

    if (mode === 'complete') {
      const key = `srv-${taxPercent}-${srvTaxesIncluded ? 'included' : 'nonIncluded'}`;
      if (acc[key]) {
        acc[key].tax_amount += taxAmount;
      } else {
        acc[key] = {
          is_percent: true,
          value: taxPercent,
          name: 'iva extras',
          tax_type: 'service',
          tax_amount: taxAmount,
          include_total_price: service.get('taxes_included', false)
        };
      }
    } else {
      const key = `iva-${taxPercent}-${srvTaxesIncluded ? 'included' : 'nonIncluded'}`;
      if (acc[key]) {
        acc[key].tax_amount += taxAmount;
      } else {
        acc[key] = {
          is_percent: true,
          value: taxPercent,
          name: 'iva',
          tax_type: 'service',
          tax_amount: taxAmount,
          include_total_price: srvTaxesIncluded
        };
      }
    }

  });

  return acc;
};

export const getTaxText = (tax, mode = "default") => {

  if(tax.tax_type === 'rate') {
    return mode === 'default' ?
      '_%iva%_': '_%iva_habitaciones%_';
  }

  if(tax.tax_type === 'service') {
    return '_%iva_extras%_'
  }

  return  `${tax.name}`
}

// GLOSARIO.md FCL-003
export const getMandatoryFeesTotal = (rateAvail, code = MANDATORY_FEE_CODE) =>
  rateAvail.get('days', List()).reduce((total, day) =>
    total + day.get('local_taxes', List()).reduce((sum, tax) =>
      tax.get('code') === code ? sum + tax.get('tax_amount', 0) : sum, 0
    ), 0
  );

// GLOSARIO.md FCL-003
export const splitMandatoryFees = (taxes, code = MANDATORY_FEE_CODE) => ({
  mandatoryFees: taxes.filter(tax => tax.code === code),
  otherTaxes: taxes.filter(tax => tax.code !== code)
});

const isRateOrServiceTax = tax => tax.tax_type === 'rate' || tax.tax_type === 'service';

export const sumTaxAmounts = (taxes, predicate = () => true) =>
  taxes.reduce((sum, tax) => predicate(tax) ? sum + tax.tax_amount : sum, 0);

// GLOSARIO.md FCL-003 - separa la fee de destino obligatoria del resto de impuestos/tasas:
// pasa a "included" (y por tanto cuenta como parte del total "sin impuestos" via additionalFees),
// mientras que el resto de impuestos/tasas (de tarifa, de servicio, u otras locales) van a "nonIncluded".
// Unica fuente de esta logica: AvailMainSideSummary/summaryPricing.js y CustomerForm.jsx la reexportan/consumen desde aqui.
export const applyMandatoryFeeSplit = (taxes, summaryPriceBreakdown) => {
  if (!summaryPriceBreakdown) return { taxes, additionalFees: 0 };

  const { mandatoryFees, otherTaxes } = splitMandatoryFees([...taxes.included, ...taxes.nonIncluded]);
  // La fee obligatoria nunca debería llevar tax_type 'rate'/'service' (solo lo llevan los impuestos
  // de tarifa/servicio, no los locales), pero nos protegemos por si un hotel la configura mal.
  const mandatoryRateFees = mandatoryFees.filter(isRateOrServiceTax);
  const included = mandatoryFees.filter(tax => !isRateOrServiceTax(tax));
  const nonIncluded = [...otherTaxes, ...mandatoryRateFees];
  const additionalFees = included.reduce((sum, tax) => sum + tax.tax_amount, 0);

  return { taxes: { included, nonIncluded }, additionalFees };
};

export const getDisplayedTotalPrice = ({
  summaryPriceBreakdown,
  nonIncludedTaxes,
  priceBase,
  totalPriceWithTaxes,
  totalPrice,
}) => {
  if (!summaryPriceBreakdown) return totalPrice;
  return nonIncludedTaxes > 0 ? priceBase + nonIncludedTaxes : totalPriceWithTaxes;
};

export const getServiceTaxAmount = (block, service) => {
  const type = service.get('type', '');
  const occupants = block.get('adults', 0) + block.get('childs', 0);
  const serviceQuantity = service.get('quantity', 0);
  const taxAmount = service.get('tax_amount', 0);

  switch(type) {
    case 'person':
    case 'person_night':
    case 'Per person':
    case 'Per person per night':
      return taxAmount * occupants;
    case 'use':
    case 'Per use':
      return  taxAmount * serviceQuantity;
    case 'stay':
    case 'Per stay':
    default:
      return taxAmount;
  }

}

const mergeTaxesAndClassify = (rateTaxes, localTaxesBlocks, showTaxes, mode = 'default') => {
  const taggedRateTaxes = Object.values(rateTaxes).map(tax => ({ ...tax, tax_type: 'rate' }));
  const allTaxes = taggedRateTaxes.concat(localTaxesBlocks);

  const mergedByPercent = {};
  const others = [];

  allTaxes.forEach((tax) => {
    if (mode === 'default' && tax.is_percent && tax.tax_type === 'rate') {
      const key = `iva-${tax.value}-${(tax.include_total_price && showTaxes) ? 'included' : 'nonIncluded'}`;
      if (mergedByPercent[key]) {
        mergedByPercent[key].tax_amount += tax.tax_amount;
      } else {
        mergedByPercent[key] = { ...tax, name: 'iva' };
      }
    } else {
      others.push(tax);
    }
  });

  const allMerged = [...Object.values(mergedByPercent), ...others];
  const result = allMerged.reduce((acc, tax) => {
    if (showTaxes && (tax.name === 'iva' || tax.include_total_price)) {
      acc['included'].push(tax);
    } else {
      tax.name && acc['nonIncluded'].push(tax);
    }
    return acc;
  }, { included: [], nonIncluded: [] });

  return {
    included: result.included.sort((a, b) => a.tax_amount - b.tax_amount),
    nonIncluded: result.nonIncluded.sort((a, b) => a.tax_amount - b.tax_amount)
  };
};

export const concatChildAgeText = ({childsInfo, separator = "_%y%_"}) => {

  const i18n = contentGetter();
  const count = childsInfo?.size;
  let childYears = "";
  if(!count) {
    return "";
  }else if (count === 1) {
    childYears = ""+childsInfo.get(0);
  } else {
    childYears = `${childsInfo.slice(0,childsInfo.size-1).join(', ')} ${i18n.t(separator)} ${childsInfo.get(childsInfo.size-1)}`;
  }

  const totalAge = childsInfo.reduce((prev, val)=> prev+val,0);

  return (childYears && `${childYears} ${i18n.t('_%año%_', !(totalAge === 1 && childsInfo.get(childsInfo.size-1) === 1) )}`) || "";

}

export const concatChildAgeSymbol = ({childsInfo, separator = " + "}) => {

  const i18n = contentGetter();
  if(!childsInfo?.size){
    return "";
  }

  return " ( "+ childsInfo.reduce((result, child)=>{
    return (result.push(`${child} ${i18n.t('_%año%_', child !== 1 )}`));
  },List()).join(separator) + " ) ";


}


export const getRoomName = ({childsInfo, adults, childs, babies, funcName = "default", separator })=>{


  const i18n = contentGetter();

  const childsAgeText = concatChildAgeText({childsInfo, separator});

  const totalChilds = childs+babies;

  return ' (' + adults + ' ' + i18n.t('_%adulto%_', adults !== 1) + (totalChilds > 0 ? (' + ' + totalChilds + ' ' + i18n.t('_%niño%_', totalChilds !== 1))+ (childsAgeText ? " - "+ childsAgeText : "") : '') + ')';
}

export const decodeBlackEmail = (emailB64, hotelId) => {
  //comprobacion por si aun no se recuperan ofuscados 
  // los emails al depender de caché
  if(emailB64.includes('@')) {
    return emailB64;
  }


  const $BLACKLIST_EMAIL_SECRET = 0x3ACB2; //Igual en HotelDescriptiveInfoAvail

  const number = hotelId ^ $BLACKLIST_EMAIL_SECRET;
  const bytes = atob(emailB64);
  let decoded = '';
  for (let i = 0; i < bytes.length; i++) {
    const charCode = bytes.charCodeAt(i) ^ (number % 256); 
    decoded += String.fromCharCode(charCode);
  }

  return decoded;
}

export const getStoredUserSafe = () => {
  const raw = localStorage.getItem("login_user");
  if (!raw) return null;
  try { return JSON.parse(raw); } catch { return null; }
};

export const shouldRestoreUser = (getState) => {
  const isFideltourActive =
    getState().getIn(['customer','loyalty','data','loyalty','code']) === 'fideltour';

  const isUserLogin = localStorage.getItem("login_user") !== null;
  const loginConfig = window.frontLoader?.['cms-login']?.config || false;

  return isFideltourActive && isUserLogin && !loginConfig;
};

/**
 * Devuelve el texto de etiqueta de precio total o subtotal según el contexto
 * @param {boolean} showTaxes
 * @param {boolean} summaryPriceBreakdown - Si se muestra o no el desglose de precios
 * @param {{ nonIncluded: Array }} taxes
 * @param {string} [variant='precio'] - Variante del texto ('precio', 'importe', etc.)
 * @returns {string}
 */
export const getTotalPriceLabel = ({ showTaxes, summaryPriceBreakdown, taxes, variant = 'precio' }) => {
  const hasNonIncludedTaxes = taxes.nonIncluded.length > 0;
  const isSubtotal = !showTaxes || (hasNonIncludedTaxes && (isUsDomain() || summaryPriceBreakdown));

  return `_%${variant} ${isSubtotal ? 'subtotal' : 'total'}%_`;
};

export const resolveDiscountIdsToShow = (usedDiscounts) => {
  if (!usedDiscounts || usedDiscounts.size === 0) return List();

  const exclusive = usedDiscounts.find(d => d.get('overlapping', false) === 'exclusive');
  if (exclusive) return List([exclusive.get('id')]);

  return usedDiscounts.map(d => d.get('id')).toSet().toList();
};